export default {
  route: {
    sysOrg: '机构管理',
    sysDic: '字典管理',
    sys: '系统设置',
    role: '角色管理',
    perm: '权限管理',
    user: '用户管理',
    sysLog: '系统日志',
    logTranslate: '日志字典',
    public: '公共模块',
    news: '资讯管理',
    newsMessage: '新闻资讯',
    newsMessages: '资讯',
    policy: '政策法规',
    regionalNews: '区域新闻',
    newsAuditRecord: '资讯审核',
    publicLesson: '推荐课程',
    publicMessage: '通知公告',
    notice: '通知消息',
    publicAuditRecord: '通知审核',
    platform: '平台管理',
    platformList: '平台列表',
    platformProd: '平台商品',
    material: '材料管理',
    goods: '商品管理',
    goodsType: '单品商品',
    goodsCombination: '商品组合',
    memberManage: '学员管理',
    member: '学员信息',
    financeManage: '财务管理',
    payment: '缴费记录',
    order: '订单记录',
    enterpriseManage: '企业管理',
    enterprise: '企业信息',
    commission: '提成比例',
    settlement: '结算管理',
    purchase: '购买管理',
    platformGoods: '平台商品',
    swipe: '轮播图管理',
    training: '教育培训',
    paper: '试卷管理',
    question: '题库管理',
    questionLib: '题库管理', // 代理商题库
    special: '推荐专题',
    clwPlatform: '监控平台管理',
    adManage: '广告管理'
  },
  navbar: {
    logOut: '注销',
    screenfull: '全屏'
  },
  login: {
    logIn: '登录',
    username: '账号',
    password: '密码'
  },
  table: {
    add: '增加',
    id: '序号',
    actions: '操作',
    search: '搜索',
    audit: '批量审批',
    export: '导出'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js